import {NgModule} from '@angular/core';
import {PaymentModalComponent} from './payment-modal.component';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule, DecimalPipe} from '@angular/common';
import {StripeCardListComponent} from './stripe/stripe-card-list/stripe-card-list.component';
import {StripeCardFormModalComponent} from './stripe/stripe-card-form-modal/stripe-card-form-modal.component';
import {StripeCardItemComponent} from './stripe/stripe-card-item/stripe-card-item.component';
import {PermissionModule} from '../../../../shared/permission';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {PortalSelectModule} from '../../../shared/modules/portal-select/portal-select.module';
import {InputTrimmerModule} from '../../../shared/modules/input-trimmer/input-trimmer.module';
import {TooltipModule} from '../../../shared/modules/tooltip/tooltip.module';
import {NgxStripeModule} from 'ngx-stripe';

@NgModule({
  declarations: [
    StripeCardItemComponent,
    StripeCardFormModalComponent,
    StripeCardListComponent,
    PaymentModalComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    PermissionModule,
    NgxMatSelectSearchModule,
    PortalSelectModule,
    InputTrimmerModule,
    TooltipModule,
    NgxStripeModule
  ],
  exports: [
    StripeCardItemComponent,
    StripeCardFormModalComponent,
    StripeCardListComponent,
    PaymentModalComponent
  ],
  providers: [
    DecimalPipe
  ]
})

export class PaymentModalModule {
}
